import { render, staticRenderFns } from "./DRoutedTabs.vue?vue&type=template&id=1fd3972c"
import script from "./DRoutedTabs.vue?vue&type=script&lang=js"
export * from "./DRoutedTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports